import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { costingUrlKey, openCostingChannelWhSplitAssockey, openCostingQtySizeSplitAssockey } from "../CostingDetails/data";
import { Box, Typography } from "@mui/material";
import { qtySizeSplitColumns, whQtyTableTypes } from "./data";
import { deleteTableColumn } from "data/globalData";
import QtySizeWiseSplitTable from "./QtySizeWiseSplitTable/QtySizeWiseSplitTable";
import ChannelWarehouseSplitTable from "./ChannelWarehouseSplitTable/ChannelWarehouseSplitTable";

const WarehouseQty = ({ selectedCostingWhDetails, setSelectedCostingWhDetails, selectedCostingDetails }) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();

	let [searchParams, setSearchParams] = useSearchParams();
	let [qtySizeSplitRows, setQtySizeSplitRows] = useState([]);
	let [channelWhRows, setChannelWhRows] = useState([]);
	let [qtySizeSplitTotal, setQtySizeSplitTotal] = useState({ id: new Date().valueOf() });
	let [channelWhTotal, setChannelWhTotal] = useState({ id: new Date().valueOf() });

	const [editMode, setEditMode] = useState("");

	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setSelectedCostingWhDetails();
			try {
				const res = await axios.get(`/api/sourcing/costing_qty_working_data/${id}`);
				const result = res.data.result;
				setSelectedCostingWhDetails(() => {
					let obj = { ...result };
					// delete obj[openCostingChannelWhSplitAssockey];
					// delete obj[openCostingQtySizeSplitAssockey];
					return obj;
				});
				setQtySizeSplitRows(
					result?.[openCostingQtySizeSplitAssockey]?.length ? result?.[openCostingQtySizeSplitAssockey] : []
				);
				setChannelWhRows(
					result?.[openCostingChannelWhSplitAssockey]?.length ? result?.[openCostingChannelWhSplitAssockey] : []
				);
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		let id = searchParams.get(costingUrlKey);
		if (id && id !== selectedCostingWhDetails?.style_ref_no) fetch();
		else {
			setSelectedCostingWhDetails(null);
		}
	}, [searchParams]);

	const handleQtySizeSplitTableSave = async (data, deletedRowIds) => {
		const res = await axios.put(`/api/sourcing/update_size_qty_split_rows/${selectedCostingWhDetails?.style_ref_no}`, {
			rows: data,
			deletedRowIds,
		});
		return res.data.result;
	};
	const handleChannelWarehouseSplitTableSave = async (data, deletedRowIds) => {
		const res = await axios.put(`/api/sourcing/update_channel_wh_qty_split_rows/${selectedCostingWhDetails?.style_ref_no}`, {
			rows: data,
			deletedRowIds,
		});
		return res.data.result;
	};
	if (!selectedCostingWhDetails) return <div>Loading...</div>;
	return (
		<Box pt={2}>
			<Typography variant="h6" pb={2}>
				Warehouse Quantity Details
			</Typography>

			<QtySizeWiseSplitTable
				rows={qtySizeSplitRows}
				setRows={setQtySizeSplitRows}
				totalRow={qtySizeSplitTotal}
				setTotalRow={setQtySizeSplitTotal}
				editMode={editMode === whQtyTableTypes.qty_size_split.key}
				setEditMode={(mode) => setEditMode(mode ? whQtyTableTypes.qty_size_split.key : "")}
				mode={editMode === whQtyTableTypes.qty_size_split.key || editMode === "" ? "edit" : ""}
				handleSave={handleQtySizeSplitTableSave}
			/>
			<Box pb={2}></Box>
			<ChannelWarehouseSplitTable
				rows={channelWhRows}
				setRows={setChannelWhRows}
				totalRow={channelWhTotal}
				setTotalRow={setChannelWhTotal}
				editMode={editMode === whQtyTableTypes.channel_wh_qty_split.key}
				setEditMode={(mode) => setEditMode(mode ? whQtyTableTypes.channel_wh_qty_split.key : "")}
				mode={editMode === whQtyTableTypes.channel_wh_qty_split.key || editMode === "" ? "edit" : ""}
				handleSave={handleChannelWarehouseSplitTableSave}
			/>
		</Box>
	);
};

export default WarehouseQty;
